import {
    COMPARE_PAGE_ADD_PRODUCT,
    COMPARE_PAGE_CLEARALL,
    COMPARE_PAGE_REMOVE_PRODUCT,
    GALLERY_VIDEO_PLAYER_ANALYTICS,
    GET_GALLERY_DETAILS_BY_ID_ERROR,
    NAVIGATION_DATA_CLICK,
    ON_COMPARE_PAGE_READY,
    ON_PAGE_READY,
    PRODUCT_FILTERS_APPLIED,
    PROMOTED_FILTERS_APPLIED,
    PROMOTED_FILTERS_RESET,
    SB_PAGE_CHANGE,
    SEARCH_RESULT_CLICK,
    TRIGGER_ANALYTICS_RESET,
    TRIGGER_STORE_SEARCH_EVENT,
    BOPIS_DEFAULT_STORE_CHANGE,
} from '../actionTypes/AnalyticsActionTypes';

export const searchResultClick = (payload) => ({
    type: SEARCH_RESULT_CLICK,
    payload,
});

export const sbPageChange = (payload) => ({
    type: SB_PAGE_CHANGE,
    payload,
});

export const comparePageLoad = (payload) => ({
    type: ON_COMPARE_PAGE_READY,
    payload,
});

export const promotedFilterChange = (payload) => ({
    type: PROMOTED_FILTERS_APPLIED,
    payload,
});

export const promotedFilterReset = (payload) => ({
    type: PROMOTED_FILTERS_RESET,
    payload,
});

export const getGalleryDetailsByIdError = (payload) => ({
    type: GET_GALLERY_DETAILS_BY_ID_ERROR,
    payload,
});

export const compareAddProduct = (payload) => ({
    type: COMPARE_PAGE_ADD_PRODUCT,
    payload,
});

export const compareRemoveProduct = (payload) => ({
    type: COMPARE_PAGE_REMOVE_PRODUCT,
    payload,
});

export const compareClearAllProducts = (payload) => ({
    type: COMPARE_PAGE_CLEARALL,
    payload,
});

export const productFilterApplied = (payload) => ({
    type: PRODUCT_FILTERS_APPLIED,
    payload,
});

export const onPageReady = (payload) => ({
    type: ON_PAGE_READY,
    payload,
});

export const analyticsReset = (payload) => ({
    type: TRIGGER_ANALYTICS_RESET,
    payload,
});

export const navigationData = (payload) => ({
    type: NAVIGATION_DATA_CLICK,
    payload,
});

export const videoPlayerAnalytics = (payload) => ({
    type: GALLERY_VIDEO_PLAYER_ANALYTICS,
    payload,
});

export const triggerStoreSearchEvent = (searchText) => ({
    type: TRIGGER_STORE_SEARCH_EVENT,
    searchText,
});

export const bopisDefaultStoreChange = () => ({
    type: BOPIS_DEFAULT_STORE_CHANGE,
});
